import {Directive, HostListener} from '@angular/core';
import {MatTooltip} from '@angular/material/tooltip';

@Directive({
    selector: '[matTooltip]',
})
export class TooltipTapDirective {
    constructor(private tooltip: MatTooltip) {
    }

    @HostListener('click')
    onClick(): void {
        if (window.matchMedia('(hover: none)').matches) {
            this.tooltip.toggle();
        }
    }
}
